import { useState } from 'react';

/**
 * Validation timing of the spec: an error shows after its field was blurred, or after a submit attempt.
 * `errors` holds only the failing fields.
 */
export const useFormErrors = (errors: Record<string, string>) => {
    const [touched, setTouched] = useState<ReadonlySet<string>>(new Set());
    const [submitted, setSubmitted] = useState(false);

    return {
        submitted,
        count: Object.keys(errors).length,
        blur: (key: string) => setTouched((prev) => new Set(prev).add(key)),
        shown: (key: string): string | undefined => (submitted || touched.has(key) ? errors[key] : undefined),
        /** Call on submit. Returns true when the form may be sent. */
        attempt: (): boolean => {
            setSubmitted(true);
            return Object.keys(errors).length === 0;
        },
    };
};

/** Moves focus to the first control marked invalid, after the next render. */
export const focusFirstInvalid = (root: HTMLElement | null): void => {
    window.setTimeout(() => {
        root?.querySelector<HTMLElement>('[aria-invalid="true"], [data-invalid="true"]')?.focus();
    }, 0);
};
